'use strict';
var win            = require( '@rei/browser-shim' ).win;
var ATTRIBUTE_NAME = 'data-client-store';

/**
 *  Build Document Query
 *  @private
 *  @param      {String} namespace
 *  @returns    {String}
 */
var buildDocumentQuery = function ( namespace ) {
    if ( !namespace || typeof namespace !== 'string' ) {
        throw new TypeError( 'No usable namespace, we got problems' );
    }

    return [ '[', ATTRIBUTE_NAME, '="', namespace, '"]' ].join( '' );
};


/**
 * Simple shallow merge method: Combines n objects into 1. Subsequent
 * matching object properties overwrite previous.
 * @returns { Object } Merged objects.
 */
var merge = function () {
    var merged = {};
    var args = Array.prototype.slice.call( arguments );

    args.forEach( function (obj) {
        var keys = Object.getOwnPropertyNames( obj );

        keys.forEach( function ( key ) {
            merged[key] = obj[key];
        });
    });

    return merged;
};

/**
 *  Retrieve Data
 *  @desc       This function will look client store elements returns their data
 *  @param      {String} namespace
 *  @returns    {Object|Null}
 */
var retrieveData = function ( namespace ) {
    var documentQuery = buildDocumentQuery( namespace );
    var elements      = win.document.querySelectorAll( documentQuery );

    if ( !elements ) {
        return {};
    }

    try {
        var ret = {};
        var forEach = typeof elements.forEach === 'function' ? elements.forEach : Array.prototype.forEach;

        forEach.call( elements, function ( el ) {
            if( el && ( el.text || el.textContent ) ) {
                var text = JSON.parse( el.text || el.textContent );
                ret      = merge( ret, text );
            }
        } );
        return ret;
    } catch ( e ) {
        throw new Error( e );
    }
};

module.exports = {
    retrieveData: retrieveData,
    merge: merge
};
